var _rect, _g, _rect2, _rect3, _g2, _rect4, _circle, _circle2, _circle3, _g3, _g4, _path, _path2, _path3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g5, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingTimeline3Image(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 440,
    viewBox: "0 0 440 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 440,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_243_5519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.79248 254.838L157.304 230.039C165.538 228.721 173.95 229.037 182.061 230.97C190.172 232.902 197.824 236.414 204.578 241.303C211.332 246.193 217.057 252.365 221.425 259.467C225.794 266.569 228.721 274.462 230.039 282.696L254.838 437.274",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.274 185.162L282.696 209.961C274.462 211.279 266.05 210.963 257.939 209.03C249.828 207.098 242.177 203.586 235.422 198.697C228.668 193.807 222.943 187.635 218.575 180.533C214.206 173.431 211.279 165.538 209.961 157.304L185.162 2.79236",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0186 398.247L182.768 271.46C192.65 257.821 207.541 248.663 224.17 245.995C240.8 243.327 257.808 247.369 271.46 257.232L398.247 348.982",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.981 41.7528L257.232 168.54C252.344 175.301 246.173 181.031 239.069 185.405C231.966 189.779 224.071 192.711 215.834 194.032C207.598 195.353 199.181 195.039 191.066 193.106C182.951 191.173 175.297 187.66 168.54 182.768L41.7527 91.0184",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.168 340.87L166.945 254.905C173.911 250.319 181.713 247.151 189.905 245.582C198.096 244.012 206.517 244.072 214.685 245.757C222.853 247.443 230.61 250.721 237.511 255.405C244.412 260.089 250.322 266.087 254.905 273.055L340.87 403.832",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.832 99.1296L273.055 185.095C266.089 189.681 258.287 192.849 250.095 194.418C241.904 195.988 233.483 195.928 225.315 194.243C217.147 192.557 209.39 189.279 202.489 184.595C195.588 179.911 189.678 173.913 185.095 166.945L99.1296 36.168",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.455 435.479L207.168 282.164C208.833 273.985 212.095 266.216 216.767 259.301C221.44 252.385 227.432 246.46 234.399 241.865C241.366 237.27 249.171 234.095 257.368 232.522C265.564 230.949 273.991 231.009 282.164 232.699L435.479 264.545",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.545 4.58752L232.699 157.836C229.275 174.326 219.448 188.783 205.374 198.032C191.301 207.282 174.131 210.568 157.637 207.168L4.72046 175.455",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2944 298.12L160.562 242.539C176.301 236.548 193.773 237.049 209.143 243.93C224.513 250.81 236.524 263.51 242.539 279.238L298.12 425.506",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.506 141.946L279.239 197.461C263.507 203.383 246.071 202.832 230.745 195.929C215.42 189.026 203.452 176.333 197.462 160.629L141.946 14.3608",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.779 420.653L193.938 277.909C197.353 270.297 202.235 263.434 208.304 257.71C214.374 251.986 221.512 247.515 229.31 244.551C237.108 241.587 245.414 240.189 253.753 240.437C262.092 240.685 270.3 242.574 277.909 245.996L420.653 310.154",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.221 19.3473L245.996 162.091C242.574 169.697 237.688 176.554 231.616 182.271C225.544 187.987 218.405 192.452 210.607 195.409C202.81 198.367 194.506 199.759 186.17 199.506C177.834 199.254 169.629 197.362 162.025 193.938L19.3472 129.779",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4243 375.576L175.122 264.878C181.019 258.977 188.02 254.297 195.726 251.104C203.432 247.91 211.692 246.267 220.033 246.267C228.375 246.267 236.634 247.91 244.34 251.104C252.046 254.297 259.048 258.977 264.944 264.878L375.576 375.576",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.576 64.4243L264.944 175.122C259.048 181.023 252.046 185.703 244.34 188.896C236.634 192.09 228.375 193.733 220.033 193.733C211.692 193.733 203.432 192.09 195.726 188.896C188.02 185.703 181.019 181.023 175.122 175.122L64.4243 64.4243",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 440V283.493C220.018 266.659 226.713 250.52 238.616 238.616C250.52 226.713 266.659 220.018 283.493 220H440",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 0V156.507C219.982 173.341 213.287 189.48 201.384 201.384C189.48 213.287 173.341 219.982 156.507 220H0",
    stroke: "#838383",
    strokeMiterlimit: 10
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 100.5,
    width: 330,
    height: 206,
    rx: 4.5,
    fill: "white",
    stroke: "#252525"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_243_5519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 100,
    width: 331,
    height: 207
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 100.5,
    width: 330,
    height: 206,
    rx: 4.5,
    fill: "white",
    stroke: "#252525"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_243_5519)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.3186,
    y: 96.6536,
    width: 305.18,
    height: 39.5152,
    rx: 4.5,
    fill: "#252525",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.2466,
    y: 109.321,
    width: 14.18,
    height: 14.1803,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.601,
    y: 103.744,
    width: 25.33,
    height: 25.3349,
    rx: 12.665,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.801,
    y: 114.385,
    width: 39.69,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.336,
    y: 114.385,
    width: 28.35,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.531,
    y: 114.385,
    width: 28.35,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.3186,
    y: 143.246,
    width: 305.18,
    height: 39.5152,
    rx: 4.5,
    fill: "#252525",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.601,
    y: 150.336,
    width: 25.33,
    height: 25.3349,
    rx: 12.665,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.801,
    y: 160.978,
    width: 39.69,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.336,
    y: 160.978,
    width: 28.35,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.531,
    y: 160.978,
    width: 28.35,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.2466,
    y: 156.321,
    width: 14.18,
    height: 14.1803,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.3186,
    y: 189.159,
    width: 305.18,
    height: 39.5152,
    rx: 4.5,
    fill: "#252525",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.2466,
    y: 201.826,
    width: 14.18,
    height: 14.1803,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.601,
    y: 196.249,
    width: 25.33,
    height: 25.3349,
    rx: 12.665,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.801,
    y: 206.891,
    width: 39.69,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.336,
    y: 206.891,
    width: 28.35,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.531,
    y: 206.891,
    width: 28.35,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.3186,
    y: 235.072,
    width: 305.18,
    height: 39.5152,
    rx: 4.5,
    fill: "#252525",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.2466,
    y: 247.74,
    width: 14.18,
    height: 14.1803,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.601,
    y: 242.162,
    width: 25.33,
    height: 25.3349,
    rx: 12.665,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.801,
    y: 252.804,
    width: 39.69,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.336,
    y: 252.804,
    width: 28.35,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.531,
    y: 252.804,
    width: 28.35,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.3186,
    y: 280.985,
    width: 305.18,
    height: 39.5152,
    rx: 4.5,
    fill: "#252525",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.2466,
    y: 293.652,
    width: 14.18,
    height: 14.1803,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.601,
    y: 288.075,
    width: 25.33,
    height: 25.3349,
    rx: 12.665,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.801,
    y: 298.716,
    width: 39.69,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.336,
    y: 298.716,
    width: 28.35,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.531,
    y: 298.716,
    width: 28.35,
    height: 4.05152,
    rx: 1,
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 329.913,
    height: 38.7095,
    rx: 4.5,
    transform: "matrix(1 0 0 -1 55 93.7096)",
    fill: "#252525",
    stroke: "#252525"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.1784,
    cy: 74.8548,
    r: 5.29461,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.7094,
    cy: 74.8548,
    r: 5.29461,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.241,
    cy: 74.8548,
    r: 5.29461,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_243_5519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396 89.6007H431.201",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.601 107.201V72.0001",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.601 80.173C413.089 82.3899 411.997 84.4306 410.435 86.0855C408.874 87.7405 406.9 88.9499 404.717 89.5896C404.717 89.5896 412.49 92.5655 413.656 99.6946C413.656 99.6946 415.488 89.5896 423.928 89.5896C423.872 89.5896 416.221 90.1781 413.601 80.173Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_243_5519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8149 79.5808H36.3612",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5881 87.354V71.8077",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5881 75.4172C28.3622 76.3963 27.8797 77.2976 27.1902 78.0285C26.5007 78.7593 25.6291 79.2935 24.6648 79.576C24.6648 79.576 28.0977 80.8903 28.6127 84.0388C28.6127 84.0388 29.4218 79.576 33.149 79.576C33.1245 79.576 29.7455 79.8359 28.5881 75.4172Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339.22 249.366H354",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M346.61 256.757V241.976",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M346.61 245.408C346.395 246.339 345.936 247.196 345.281 247.891C344.625 248.585 343.797 249.093 342.88 249.362C342.88 249.362 346.144 250.611 346.633 253.605C346.633 253.605 347.403 249.362 350.946 249.362C350.923 249.362 347.71 249.609 346.61 245.408Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 322,
    width: 241,
    height: 60,
    rx: 5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 350.5,
    width: 221,
    height: 3,
    fill: "#252525"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 337.5,
    width: 17,
    height: 29,
    rx: 8.5,
    fill: "white",
    stroke: "#252525",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 344,
    width: 3,
    height: 16,
    fill: "#252525"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 283,
    y: 344,
    width: 3,
    height: 16,
    fill: "#252525"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 322,
    width: 80,
    height: 60,
    rx: 5,
    fill: "#252525"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 336,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_243_5519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.91 365.995H159.456",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.683 373.768V358.222",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.683 361.832C151.457 362.811 150.975 363.712 150.285 364.443C149.596 365.174 148.724 365.708 147.76 365.99C147.76 365.99 151.193 367.305 151.708 370.453C151.708 370.453 152.517 365.99 156.244 365.99C156.22 365.99 152.841 366.25 151.683 361.832Z",
    fill: "#252525"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M242.444 407.238H257.991",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M250.218 415.011V399.464",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250.218 403.074C249.992 404.053 249.509 404.954 248.82 405.685C248.13 406.416 247.258 406.95 246.294 407.232C246.294 407.232 249.727 408.547 250.242 411.695C250.242 411.695 251.051 407.232 254.778 407.232C254.754 407.232 251.375 407.492 250.218 403.074Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M228.796 405.071L228.781 405.069L228.767 405.067L206.711 402.717C205.964 402.615 205.203 402.819 204.607 403.281L186.689 416.342C186.688 416.342 186.687 416.343 186.685 416.344C186.25 416.653 185.721 416.611 185.224 416.169C184.715 415.715 184.373 414.916 184.543 414.037L184.543 414.037L184.545 414.026L193.817 363.076L193.819 363.066L193.82 363.056C193.93 362.379 194.31 362.053 194.651 361.958C194.985 361.865 195.484 361.937 195.955 362.498L195.959 362.502L229.449 401.979C230.027 402.7 230.121 403.593 229.905 404.244C229.694 404.882 229.279 405.136 228.796 405.071Z",
    fill: "#252525",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_5519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 440,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_243_5519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.2011,
    height: 35.2011,
    fill: "white",
    transform: "translate(396 72.0001)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_243_5519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5462,
    height: 15.5462,
    fill: "white",
    transform: "translate(20.8149 71.8077)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_243_5519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5462,
    height: 15.5462,
    fill: "white",
    transform: "translate(143.91 358.222)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingTimeline3Image);
export default __webpack_public_path__ + "static/media/landing-timeline-3-image.d89acf49852a9fe1b95d1f86bd711036.svg";
export { ForwardRef as ReactComponent };